module.exports = __webpack_public_path__ + "static/img/sltj.89d9965.svg";


//////////////////
// WEBPACK FOOTER
// ./static/images/sltj.svg
// module id = Ks5E
// module chunks = 2